(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("moment"));
	else if(typeof define === 'function' && define.amd)
		define(["moment"], factory);
	else if(typeof exports === 'object')
		exports["moment-biz-locale-fr-FR"] = factory(require("moment"));
	else
		root["moment-biz-locale-fr-FR"] = factory(root["moment"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 